export type AssistantVoiceErrorCode = 'voice_empty' | 'voice_transcription_failed';

export class AssistantVoiceError extends Error {
  readonly code: AssistantVoiceErrorCode;

  constructor(code: AssistantVoiceErrorCode) {
    super(`Assistant voice note failed: ${code}`);
    this.name = 'AssistantVoiceError';
    this.code = code;
  }
}
